module.exports = __webpack_public_path__ + "img/room-wa2.bd71dd22.jpg";